const externalLinkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="14.258px" height="14.256px" viewBox="0 0 14.258 14.256" enable-background="new 0 0 14.258 14.256" xml:space="preserve">
<g id="Layer_1">
	<path fill="#FFFFFF" d="M11.272,5.273h1.326v8.982H0V1.658h8.984v1.329H1.325v9.943h9.947V5.273z M9.946,0v1.326h2.057L8.819,4.512
		l0.927,0.928l3.185-3.186v2.057h1.327V0H9.946z"/>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default externalLinkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/externalLinkSVG.js